import initVueApp from "@/core.js";
const component = require(`./../views/People.vue`).default;
initVueApp(component);
